"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSettings = exports.SettingCategory = exports.ItemTypes = void 0;
/* eslint-disable id-blacklist */
const DEFAULT_SITE_SETTINGS = {
    adjudicationOffsetTime: 1,
    autoClaimReverseTime: "10:00 PM",
    dispenseScan: 0,
    eowEmailAddress: "",
    orderApprovalEmailAddress: "",
    orderCheckInDays: 4,
    sendClinicAdminCycleCountAlertEmail: 0,
    sendClinicManagerCycleCountAlertEmail: 0,
    sendEmailNotificationFrequency: 0,
    sendIntentNotificationAdmin: 0,
    sendIntentNotificationClinicAdmin: 0,
    sendIntentNotificationClinicManager: 0,
    sendIntentNotificationClinicUser: 0,
    sendIntentNotificationManager: 0,
    sendIntentNotificationUser: 0,
    sendProvAlertEmails: 0,
    sendSiteAlertEmailsAdmin: 0,
    sendSiteAlertEmailsManager: 0,
    sendUserAlertEmails: 0,
    sendUserCycleCountAlertEmail: 0,
    signaturePadTimeout: 1
};
var ItemTypes;
(function (ItemTypes) {
    ItemTypes[ItemTypes["Boolean"] = 0] = "Boolean";
    ItemTypes[ItemTypes["Group"] = 4] = "Group";
    ItemTypes[ItemTypes["Number"] = 1] = "Number";
    ItemTypes[ItemTypes["String"] = 2] = "String";
    ItemTypes[ItemTypes["Time"] = 3] = "Time";
})(ItemTypes = exports.ItemTypes || (exports.ItemTypes = {}));
var SettingCategory;
(function (SettingCategory) {
    SettingCategory["General"] = "General";
    SettingCategory["Pad"] = "Pad";
    SettingCategory["Claim"] = "Claim";
    SettingCategory["Email"] = "Email";
})(SettingCategory = exports.SettingCategory || (exports.SettingCategory = {}));
exports.defaultSettings = {
    adjudicationOffsetTime: {
        category: SettingCategory.Claim,
        id: "adjudicationOffsetTime",
        label: "Adjudication Offset Time (hours)",
        title: "",
        type: ItemTypes.Number,
        value: DEFAULT_SITE_SETTINGS.adjudicationOffsetTime
    },
    autoClaimReverseTime: {
        category: SettingCategory.Claim,
        id: "autoClaimReverseTime",
        label: "Automatically reverse paid claims time",
        title: "",
        type: ItemTypes.Time,
        value: DEFAULT_SITE_SETTINGS.autoClaimReverseTime
    },
    dispenseScan: {
        category: SettingCategory.Claim,
        id: "dispenseScan",
        label: "Enable claim dispense barcode scan",
        title: "",
        type: ItemTypes.Boolean,
        value: DEFAULT_SITE_SETTINGS.dispenseScan
    },
    eowEmailAddress: {
        category: SettingCategory.Email,
        id: "eowEmailAddress",
        label: "EOW Address (Blank for None)",
        title: "",
        type: ItemTypes.String,
        value: DEFAULT_SITE_SETTINGS.eowEmailAddress
    },
    orderApprovalEmailAddress: {
        category: SettingCategory.Email,
        id: "orderApprovalEmailAddress",
        label: "Order Submission Approval Email",
        title: "",
        type: ItemTypes.String,
        value: DEFAULT_SITE_SETTINGS.orderApprovalEmailAddress
    },
    orderCheckInDays: {
        category: SettingCategory.Email,
        id: "orderCheckInDays",
        label: "Order Check-In Notification (Days)",
        title: "",
        type: ItemTypes.Number,
        value: DEFAULT_SITE_SETTINGS.orderCheckInDays
    },
    sendClinicAdminCycleCountAlertEmail: {
        category: SettingCategory.Email,
        id: "sendClinicAdminCycleCountAlertEmail",
        label: "Clinic Admin",
        title: "Cycle count alert email recipients: ",
        type: ItemTypes.Boolean,
        value: DEFAULT_SITE_SETTINGS.sendClinicAdminCycleCountAlertEmail
    },
    sendClinicManagerCycleCountAlertEmail: {
        category: SettingCategory.Email,
        id: "sendClinicManagerCycleCountAlertEmail",
        label: "Clinic Manager",
        title: "Cycle count alert email recipients: ",
        type: ItemTypes.Boolean,
        value: DEFAULT_SITE_SETTINGS.sendClinicManagerCycleCountAlertEmail
    },
    sendEmailNotificationFrequency: {
        category: SettingCategory.Email,
        id: "sendEmailNotificationFrequency",
        label: "Assets Summary Frequency:",
        title: "",
        type: ItemTypes.Group,
        value: DEFAULT_SITE_SETTINGS.sendEmailNotificationFrequency
    },
    sendIntentNotificationAdmin: {
        category: SettingCategory.Email,
        id: "sendIntentNotificationAdmin",
        label: "Admin",
        title: "Intent notification email recipients: ",
        type: ItemTypes.Boolean,
        value: DEFAULT_SITE_SETTINGS.sendIntentNotificationAdmin
    },
    sendIntentNotificationClinicAdmin: {
        category: SettingCategory.Email,
        id: "sendIntentNotificationClinicAdmin",
        label: "Clinic Admin",
        title: "Intent notification email recipients: ",
        type: ItemTypes.Boolean,
        value: DEFAULT_SITE_SETTINGS.sendIntentNotificationClinicAdmin
    },
    sendIntentNotificationClinicManager: {
        category: SettingCategory.Email,
        id: "sendIntentNotificationClinicManager",
        label: "Clinic Manager",
        title: "Intent notification email recipients: ",
        type: ItemTypes.Boolean,
        value: DEFAULT_SITE_SETTINGS.sendIntentNotificationClinicManager
    },
    sendIntentNotificationClinicUser: {
        category: SettingCategory.Email,
        id: "sendIntentNotificationClinicUser",
        label: "Clinic User",
        title: "Intent notification email recipients: ",
        type: ItemTypes.Boolean,
        value: DEFAULT_SITE_SETTINGS.sendIntentNotificationClinicUser
    },
    sendIntentNotificationManager: {
        category: SettingCategory.Email,
        id: "sendIntentNotificationManager",
        label: "Manager",
        title: "Intent notification email recipients: ",
        type: ItemTypes.Boolean,
        value: DEFAULT_SITE_SETTINGS.sendIntentNotificationManager
    },
    sendIntentNotificationUser: {
        category: SettingCategory.Email,
        id: "sendIntentNotificationUser",
        label: "User",
        title: "Intent notification email recipients: ",
        type: ItemTypes.Boolean,
        value: DEFAULT_SITE_SETTINGS.sendIntentNotificationUser
    },
    sendProvAlertEmails: {
        category: SettingCategory.Email,
        id: "sendProvAlertEmails",
        label: "Provider",
        title: "Provider assets email recipients: ",
        type: ItemTypes.Boolean,
        value: DEFAULT_SITE_SETTINGS.sendProvAlertEmails
    },
    sendSiteAlertEmailsAdmin: {
        category: SettingCategory.Email,
        id: "sendSiteAlertEmailsAdmin",
        label: "Clinic Admin",
        title: "Pharmacy assets email recipients: ",
        type: ItemTypes.Boolean,
        value: DEFAULT_SITE_SETTINGS.sendSiteAlertEmailsAdmin
    },
    sendSiteAlertEmailsManager: {
        category: SettingCategory.Email,
        id: "sendSiteAlertEmailsManager",
        label: "Clinic Manager",
        title: "Pharmacy assets email recipients: ",
        type: ItemTypes.Boolean,
        value: DEFAULT_SITE_SETTINGS.sendSiteAlertEmailsManager
    },
    sendUserAlertEmails: {
        category: SettingCategory.Email,
        id: "sendUserAlertEmails",
        label: "User",
        title: "User assets email recipients: ",
        type: ItemTypes.Boolean,
        value: DEFAULT_SITE_SETTINGS.sendUserAlertEmails
    },
    sendUserCycleCountAlertEmail: {
        category: SettingCategory.Email,
        id: "sendUserCycleCountAlertEmail",
        label: "User",
        title: "Cycle count alert email recipients: ",
        type: ItemTypes.Boolean,
        value: DEFAULT_SITE_SETTINGS.sendUserCycleCountAlertEmail
    },
    signaturePadTimeout: {
        category: SettingCategory.Pad,
        id: "signaturePadTimeout",
        label: "Signature Pad Timeout (minutes)",
        title: "",
        type: ItemTypes.Number,
        value: DEFAULT_SITE_SETTINGS.signaturePadTimeout // minutes
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/shared/setting.ts
// module id = 3112
// module chunks = 0